// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Mail = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M81.118 72.299H14.882a2.385 2.385 0 0 1-2.383-2.383V26.654l23.835 20.79-13.702 12.851a2 2 0 1 0 2.736 2.919l13.997-13.127 4.018 3.505c1.294 1.129 2.956 1.693 4.616 1.693 1.662 0 3.323-.564 4.617-1.692l4.023-3.509 13.992 13.13c.385.36.877.54 1.368.54a2 2 0 0 0 1.368-3.459L59.669 47.444 83.501 26.66v43.257a2.385 2.385 0 0 1-2.383 2.382Zm-31.13-21.723c-1.059.925-2.917.923-3.975.002L15.2 23.7h65.606L49.987 50.578Zm31.13-30.875H14.882a6.39 6.39 0 0 0-6.383 6.383v43.832a6.39 6.39 0 0 0 6.383 6.383h66.236a6.39 6.39 0 0 0 6.383-6.383V26.084a6.39 6.39 0 0 0-6.383-6.383Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default Mail;
